@if (selectedSize() === visualsDashboardWidgetSizingEnum.SMALL) {
    <div class="row-container small">
        <app-ice-visuals-dashboard-large-number-display
            [value]="totalListings()"
            [label]="'dashboard.visuals.components.numberDisplay.label.listingsBeingEditedStatus' | translate"
            [emptyStateMessage]="'dashboard.visuals.components.table.noData.listingsBeingEditedStatus' | translate"
            emptyStateIcon="fa-regular fa-hexagon-check"
            [state]="widgetState()"
            [isEmpty]="totalListings() === 0"
            icon="fa-solid fa-pen-to-square"
            [loading]="dataService.loading()"
        />
    </div>
} @else if (selectedSize() === visualsDashboardWidgetSizingEnum.MEDIUM_ROW) {
    <app-ice-visuals-dashboard-table-display
        [columns]="columns"
        [loading]="dataService.loading()"
        [data]="listings()"
        [state]="widgetState()"
        [maxRows]="8"
        [totalRows]="totalListings()"
        [isEmpty]="totalListings() === 0"
        icon="fa-solid fa-pen-to-square"
        emptyStateIcon="fa-regular fa-hexagon-check"
        [totalItemsTranslationKey]="'dashboard.visuals.components.table.totalItems.listingsBeingEditedStatus'"
        [emptyMessageTranslationKey]="'dashboard.visuals.components.table.noData.listingsBeingEditedStatus'"
    />
}
